__webpack_require__.p = "/qa/ar/customer-service/returns-claims/spareparts/";